<template>
  <div style="position: relative;" class="flex">
    <img
      style="position: absolute; top:8px; left:10px; z-index:999"
      :src="icons.GitIcon"
      alt=""
    />
    <el-select
      ref="selectVoucher"
      class="el-select-voucher w-100"
      v-model="voucher_id"
      filterable
      remote
      clearable
      reserve-keyword
      placeholder="Enter promotional code"
      :remote-method="onGetList"
      :loading="loading"
      @hook:mounted="value => cancalReadOnly(value, 'selectVoucher')"
      @visible-change="value => cancalReadOnly(value, 'selectVoucher')"
    >
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
      </el-option>
    </el-select>
    <!-- <el-input
      v-model="value"
      class="input-code"
      placeholder="Nhập mã KH"
    ></el-input> -->
    <button @click="handleChangeCourses" class="btn-search">Apply</button>
  </div>
</template>
<script>
import CoursesResource from "../../api/courses";
import VoucherResource from "../../api/voucher";
import GitIcon from "@/assets/img/svg_edu/gift.svg";

export default {
  name: "SearchNavBar",
  props: {
    tag: {
      type: String,
      default: "span"
    }
  },
  data() {
    return {
      icons: {
        GitIcon
      },
      voucher_id: null,
      loading: false,
      options: []
    };
  },
  methods: {
    cancalReadOnly(onOff, ref) {
      this.$nextTick(() => {
        if (!onOff) {
          const select = this.$refs[ref];
          const input = select.$el.querySelector(".el-input__inner");
          input.removeAttribute("readonly");
        }
      });
    },
    onGetList(code) {
      const body = {
        code
      };
      this.loading = true;
      VoucherResource.Search(body)
        .then(res => {
          const { error_code, data } = res;
          if (error_code === 0 && data.length > 0) {
            this.options = data.map(i => ({
              value: i.voucher_id,
              label: i.code
            }));
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleChangeCourses() {
      this.$emit("change-select-voucher", this.voucher_id);
    },
    remoteMethod(query) {}
  }
};
</script>
<style>
.el-select-voucher .el-input .el-input__inner {
  border-radius: 12px;
  border: 1px solid #8e9195;
  padding-left: 35px;
}
.el-select-voucher .el-input .el-input__inner::placeholder {
  font-size: 12px;
  color: #8e9195;
}
</style>
<style scoped>
.btn-search {
  flex-shrink: 0;
  border-radius: 12px;
  border: 1px solid #8e9195;
  color: #8e9195;
  font-size: 12px;
  padding: 5px 10px;
  margin-left: 10px;
}
</style>
